<template>
  <TenantContactReport v-if="userHasPermission" :useClientLayout="true" />
  <AdminLayout v-else page="Tenant Contact Report" title="Tenant Contact Report">
    You need permission to view this page.
  </AdminLayout>
</template>
<script lang="ts" setup>
import TenantContactReport from "../staffadmin/TenantContactReport.vue";
import { PermissionType } from "../../store/generatedFetchClient";
import { useUserStore } from "../../store/userStore";

var userHasPermission = computed(() =>
  useUserStore().hasPermission(PermissionType.ViewTenantContactReport)
);
</script>
